module.exports = __webpack_public_path__ + "static/media/lds-logo_zh.b08b3fe5.svg";